import { MAX_COUNT_TO_RENDER } from '../helpers/couponPeekConsts';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import * as React from 'react';
var styles = require('./CouponPreview.scss');
export default function renderCouponPlaceholder(props) {
    var couponCountsToRender = Math.min(MAX_COUNT_TO_RENDER, props.validCouponIndexes.length);
    return Array.apply(null, Array(couponCountsToRender)).map(function (text) { return (React.createElement("div", null,
        React.createElement(Icon, { iconName: '', className: styles.icon }))); });
}
//# sourceMappingURL=CouponPreviewPlaceholder.js.map